import { request } from './index'
import type { AxiosResponse } from 'axios'
import type { ApiResponse } from './index'

/**
 * 系统配置相关API
 */

export interface SystemConfig {
  id?: number
  configKey: string
  configValue: string
  description?: string
  configType?: string
  configGroup?: string
  enabled?: boolean
  sortOrder?: number
  remark?: string
}

export interface FeatureConfig {
  enable3DDesign: boolean
  enable2DDesign: boolean
  defaultDesignMode: string
}

// 获取所有配置
export function getAllConfigs(): Promise<AxiosResponse<ApiResponse<SystemConfig[]>>> {
  return request.get<SystemConfig[]>('/system/config/list')
}

// 根据配置键获取配置
export function getConfigByKey(configKey: string): Promise<AxiosResponse<ApiResponse<SystemConfig>>> {
  return request.get<SystemConfig>(`/system/config/key/${configKey}`)
}

// 根据配置分组获取配置列表
export function getConfigsByGroup(group: string): Promise<AxiosResponse<ApiResponse<SystemConfig[]>>> {
  return request.get<SystemConfig[]>(`/system/config/group/${group}`)
}

// 获取功能配置
export function getFeatureConfig(): Promise<AxiosResponse<ApiResponse<FeatureConfig>>> {
  return request.get<FeatureConfig>('/system/config/features')
}

// 更新功能配置
export function updateFeatureConfig(config: FeatureConfig): Promise<AxiosResponse<ApiResponse<string>>> {
  return request.put<string>('/system/config/features', config)
}

// 更新配置
export function updateConfig(id: number, config: SystemConfig): Promise<AxiosResponse<ApiResponse<string>>> {
  return request.put<string>(`/system/config/${id}`, config)
}

// 批量更新配置
export function batchUpdateConfig(configMap: Record<string, string>): Promise<AxiosResponse<ApiResponse<string>>> {
  return request.put<string>('/system/config/batch', configMap)
}

// 创建配置
export function createConfig(config: SystemConfig): Promise<AxiosResponse<ApiResponse<string>>> {
  return request.post<string>('/system/config', config)
}

// 保存或更新配置（upsert）
export function saveOrUpdateConfig(config: SystemConfig): Promise<AxiosResponse<ApiResponse<string>>> {
  return request.post<string>('/system/config/saveOrUpdate', config)
}

// 删除配置
export function deleteConfig(id: number): Promise<AxiosResponse<ApiResponse<string>>> {
  return request.delete<string>(`/system/config/${id}`)
}

// 初始化默认配置
export function initDefaultConfig(): Promise<AxiosResponse<ApiResponse<string>>> {
  return request.post<string>('/system/config/init')
}
